import { render, staticRenderFns } from "./CallOut.vue?vue&type=template&id=2572a16d&scoped=true"
import script from "./CallOut.vue?vue&type=script&lang=js"
export * from "./CallOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2572a16d",
  null
  
)

export default component.exports